<template>
  <el-container class="energy-price" direction="vertical">
    <common-panel :panel-data="panelData"/>
  </el-container>
</template>

<script>
import CommonPanel from "../../common/panel/CommonPanel";

export default {
  name: "ProtectSetting",
  components: {CommonPanel},
  data() {
    return {
      selPanel: null,
      // 分类管理
      panelData: {
        tableTitle: '环保因子列表',
        hasMenu: true,
        energyItem: [{'id': '1', 'name': '电'}, {'id': '2', 'name': '水'}, {'id': '11', 'name': '气'}, {'id': '12', 'name': '汽'}],
        hasTree: false,
        hasTreeToolbar: false,
        queryMethod: this.$api.systemManage.getSiteProtect,
        filterForm: [
          {label: '站点名称：', prop: 'siteName', type: 'input', value: '', style: 'width: 160px;margin-right: 10px;'}
        ],
        buttons: [
          {label: '设置环保因子', icon: 'zy-icon-setting-gear', type: 'updateRows', handleIndex: 1}
        ],
        methods: {
          edit: this.$api.systemManage.updateSiteProtect,
          update_prop: 'id'
        },
        tableCheck: true,
        tableProps: [
          {prop: "siteName", label: "电站名称"},
          {prop: "heatFactor", label: "标准煤当量系数"},
          {prop: "coalFactor", label: "标准煤等价值系数"},
          {prop: "emisFactor", label: "碳排放因子"}
        ],
        drawerTitle: '环保因子信息',
        dialogs: {
          add_edit: {
            title: '环保因子信息',
            width: '700px',
            items: [
              {type: 'input', prop: 'heatFactor', label: '标准煤当量系数：', placeholder: '请输入标准煤当量系数', style: 'width: 315px;'},
              {type: 'input', prop: 'coalFactor', label: '标准煤等价值系数：', placeholder: '请输入标准煤等价值系数', style: 'width: 315px;'},
              {type: 'input', prop: 'emisFactor', label: '碳排放因子：', placeholder: '请输入碳排放因子', style: 'width: 315px;'}
            ],
            rules: {
              heatFactor: [
                {required: true, message: '请输入标准煤当量系数', trigger: 'blur'}
              ],
              coalFactor: [
                {required: true, message: '请输入标准煤等价值系数', trigger: 'blur'}
              ],
              emisFactor: [
                {required: true, message: '请输入碳排放因子', trigger: 'blur'}
              ]
            },
            confirmMethod: null
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .energy-price{
    width: 100%;
    height: 100%;
  }
  .el-menu{
    background: white;
  }
  .el-menu .el-menu-item{
    font-size: 16px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/SystemSetting/ProtectSetting.vue